import { useStore } from 'zustand';
import { sessionStore } from '../domain/session/sessionStore';

/**
 * Delegations the current session is scoped to, or null when operating on the whole company.
 *
 * Lives in the auth session rather than in the userInfo query because GET /auth/userInfo doesn't
 * return it: it's chosen in the impersonation/delegation modals, so a refetch would never bring
 * it back.
 */
export const useDelegationsIds = (): number[] | null =>
	useStore(sessionStore, (state) => state.delegationsIds);

/**
 * Company from the login token, used to decide who to impersonate when a superuser lands without
 * a company. Not the *current* company — that one comes from the userInfo query.
 */
export const useDefaultCompanyId = (): number | null =>
	useStore(sessionStore, (state) => state.defaultCompanyId);
